// Reveals the "Drop a Hint" banner on a product page when arriving via a hint link
// (?hint_from=...&hint_to=...&hint_message=...). Everything needed is carried in the URL itself —
// no server round-trip, which is the whole point: the site never sends anything to the friend, the
// customer's own email/messaging app does that, so this only has to read and display it.

class DropAHintBanner extends HTMLElement {
  connectedCallback() {
    const params = new URLSearchParams(window.location.search);
    const sender = params.get('hint_from');
    const receiver = params.get('hint_to');

    if (!sender || !receiver) {
      return;
    }

    const message = params.get('hint_message');

    this.querySelector('[data-hint-banner="sender"]').textContent = sender;
    this.querySelector('[data-hint-banner="receiver"]').textContent = receiver;

    const messageEl = this.querySelector('[data-hint-banner="message"]');
    if (message) {
      messageEl.textContent = `"${message}"`;
      messageEl.hidden = false;
    }

    this.hidden = false;

    const dismissButton = this.querySelector('.drop-a-hint-banner__dismiss');
    dismissButton?.addEventListener('click', () => {
      this.hidden = true;
    });

    // Tidy the address bar once the banner has what it needs — keeps the link from lingering
    // if the visitor bookmarks or reshares the page.
    params.delete('hint_from');
    params.delete('hint_to');
    params.delete('hint_message');
    const query = params.toString();
    const newUrl = window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
    window.history.replaceState(null, '', newUrl);
  }
}

if (!window.customElements.get('drop-a-hint-banner')) {
  window.customElements.define('drop-a-hint-banner', DropAHintBanner);
}
